define('view/module/AboutView',['require','lib/view/LayoutView','Config'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Config = require('Config');

    return LayoutView.extend({

        template: '#about_module',
        modelEvents: {
            'change': 'render'
        },

        serializeData: function () {
            var result = LayoutView.prototype.serializeData.apply(this);
            result.current_url = location.href;
            result.map_key = Config.getInstance().getOption('map_api_key');
            result.work_day_names = new Date().getWeekDaysList('medium');

            _.each(result.opening_hours_info, function (value, key) {
                value.day_name_short = result.work_day_names[key];
            });

            return result;
        }

    });

});
